import * as React from "react"
import * as CheckboxPrimitive from "@radix-ui/react-checkbox"
import { cva } from "class-variance-authority"
import { cn } from "../../lib/utils"
import { Icon } from "./icon"
import { Check } from "lucide-react"

const checkboxVariants = cva(
  "peer h-4 w-4 shrink-0 rounded-sm border shadow focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
  {
    variants: {
      variant: {
        default: "border-primary data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground",
        info: "border-info data-[state=checked]:bg-info data-[state=checked]:text-info-foreground",
        success: "border-success data-[state=checked]:bg-success data-[state=checked]:text-success-foreground",
        warning: "border-warning data-[state=checked]:bg-warning data-[state=checked]:text-warning-foreground",
        danger: "border-danger data-[state=checked]:bg-danger data-[state=checked]:text-danger-foreground",
        dark: "border-dark data-[state=checked]:bg-dark data-[state=checked]:text-dark-foreground",
        white: "border-white-custom-border data-[state=checked]:bg-white-custom data-[state=checked]:text-white-custom-foreground",

        "soft": "border-primary/50 data-[state=checked]:bg-primary/20 data-[state=checked]:text-primary",
        "soft-primary": "border-primary/50 data-[state=checked]:bg-primary/20 data-[state=checked]:text-primary",
        "soft-secondary": "border-secondary/50 data-[state=checked]:bg-secondary/50 data-[state=checked]:text-secondary-foreground",
        "soft-info": "border-info/50 data-[state=checked]:bg-info/20 data-[state=checked]:text-info",
        "soft-success": "border-success/50 data-[state=checked]:bg-success/20 data-[state=checked]:text-success",
        "soft-warning": "border-warning/50 data-[state=checked]:bg-warning/20 data-[state=checked]:text-warning",
        "soft-danger": "border-danger/50 data-[state=checked]:bg-danger/20 data-[state=checked]:text-danger",

        "outline-primary": "border-primary data-[state=checked]:bg-transparent data-[state=checked]:text-primary",
        "outline-secondary": "border-secondary data-[state=checked]:bg-transparent data-[state=checked]:text-secondary-foreground",
        "outline-info": "border-info data-[state=checked]:bg-transparent data-[state=checked]:text-info",
        "outline-success": "border-success data-[state=checked]:bg-transparent data-[state=checked]:text-success",
        "outline-warning": "border-warning data-[state=checked]:bg-transparent data-[state=checked]:text-warning",
        "outline-danger": "border-danger data-[state=checked]:bg-transparent data-[state=checked]:text-danger",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

const Checkbox = React.forwardRef(({ className, variant, ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    className={cn(checkboxVariants({ variant }), className)}
    {...props}
  >
    <CheckboxPrimitive.Indicator
      className={cn("flex items-center justify-center text-current")}
    >
      <Icon icon={Check} size="xs" color="white" />
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
))
Checkbox.displayName = CheckboxPrimitive.Root.displayName

export { Checkbox, checkboxVariants }
